import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery, Carousel, LazyImage } from '@grandvisionhq/common';

const VariantSwitcherItem = ({ image , sku , isActive , onClick , disableTabIndex ,  })=>{
    const handleClick = React.useCallback((e)=>{
        onClick(sku);
        e.preventDefault();
        e.stopPropagation();
    }, [
        onClick,
        sku
    ]);
    if (!image) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("button", {
        onClick: handleClick,
        "aria-label": image.alt || '',
        className: classnames('variant-switcher-item', {
            'variant-switcher-item--active': isActive
        }),
        tabIndex: disableTabIndex ? -1 : undefined
    }, /*#__PURE__*/ React.createElement(LazyImage, {
        className: "variant-switcher-item__image",
        src: image.url,
        alt: image.alt || '',
        // 16:9 ratio
        height: 22.5,
        width: 40
    }));
};
const VariantSwitcher = ({ variants , activeSku , onVariantChange , className , tabIndex ,  })=>{
    const [activeIndex, setActiveIndex] = React.useState(0);
    const itemsPerSlide = MediaQuery.useIsPhone() ? 2 : 3;
    const carouselItems = React.useMemo(()=>{
        const max = Math.ceil(variants.length / itemsPerSlide);
        const items = [];
        for(let i = 0; i < max; i++){
            const start = i * itemsPerSlide;
            const end = (i + 1) * itemsPerSlide;
            items.push(/*#__PURE__*/ React.createElement("div", {
                key: `variant-switcher-${i}`,
                className: classnames('variant-switcher__slide', {
                    'variant-switcher__slide--single': max === 1
                })
            }, variants.slice(start, end).map(({ sku , image  })=>/*#__PURE__*/ React.createElement(VariantSwitcherItem, {
                    key: sku,
                    image: image,
                    sku: sku,
                    isActive: sku === activeSku,
                    onClick: onVariantChange,
                    disableTabIndex: tabIndex === -1 || activeIndex !== i
                })
            )));
        }
        return items;
    }, [
        variants,
        itemsPerSlide,
        activeSku,
        onVariantChange,
        tabIndex,
        activeIndex
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('variant-switcher', className)
    }, /*#__PURE__*/ React.createElement(Carousel, {
        pagination: false,
        onIndexChange: setActiveIndex,
        loopNavigationFocus: true
    }, carouselItems));
};

export { VariantSwitcher, VariantSwitcherItem, VariantSwitcher as default };
//# sourceMappingURL=VariantSwitcher.js.map
